import type { FC } from "react";

import { LoyaltyContactFormCheckboxSection as UILoyaltyContactFormCheckboxSection } from "@jti/ui/components/LoyaltyContactForm";

import type { loyaltyContactFormCheckboxSectionInputs } from "./LoyaltyContactFormCheckboxSection.builder";

export type LoyaltyContactFormCheckboxSectionProps = BuilderComponentProps<
  typeof loyaltyContactFormCheckboxSectionInputs
>;

export const LoyaltyContactFormCheckboxSection: FC<LoyaltyContactFormCheckboxSectionProps> = ({
  checkboxesData,
  validationErrorMessage,
  required,
  sectionName,
  sectionTitle,
  type,
  titleAs,
}) => {
  return (
    <UILoyaltyContactFormCheckboxSection
      checkboxesData={checkboxesData}
      validationErrorMessage={validationErrorMessage}
      required={required}
      sectionName={sectionName}
      sectionTitle={sectionTitle}
      type={type}
      titleAs={titleAs}
    />
  );
};
